import { useMutation } from '@tanstack/react-query';
import { useMixpanel } from 'react-mixpanel-browser';

import { PostChangeSatelliteModePayload, PostChangeSatelliteModeResponse } from '@/api/device/types';
import { refreshCachedDevice } from '@/api/devices';
import { axios } from '@/common/axios';
import { MutationConfig } from '@/common/react-query';
import { useErrorContext } from '@/context/ErrorContext';

export const postChangeSatelliteMode = (
    payload: PostChangeSatelliteModePayload
): Promise<PostChangeSatelliteModeResponse> => {
    return axios.post('/device/change-mode', payload);
};

type UsePostChangeSatelliteModeOptions = {
    config?: MutationConfig<typeof postChangeSatelliteMode>;
    data?: PostChangeSatelliteModePayload;
};

export const usePostChangeSatelliteMode = ({ config }: UsePostChangeSatelliteModeOptions = {}) => {
    const { createErrorHandler } = useErrorContext();
    const mixpanel = useMixpanel();
    return useMutation({
        ...config,
        mutationFn: postChangeSatelliteMode,
        onSuccess: (_data, variables) => {
            refreshCachedDevice(variables.spotterId);
            mixpanel?.track('Device satellite data mode updated', {
                spotterId: variables.spotterId,
                mode: variables.mode,
                messagePeriod: `${variables.messagePeriod} hour(s)`,
            });
        },
        onError: createErrorHandler('change satellite data mode'),
    });
};
